import Component from '../abstracts/Component';
import {isMobile, MobileBreakpoint} from '../utils/MobileUtils';
// import card lookbook
import LookbookProductCard from './LookbookProductCard';
import TrackingComponent from './TrackingComponent';

// LB_MODAL_EVENTS
export default class LookbookModalComponent extends Component {
  get SELECTORS() {
      return {
        close: '.lb-modal__close',
        addBtn: '.add-to-cart-text',
        addedBtn: '.added-to-cart-text',
        lookbookCard: '.w-lookbook-product-card',
        lookbookPage: '.p-lookbook-page',
        carousel: '.lb-modal__product-list__products',
        carouselElement: 'w-lookbook-product-card',
        prevArrow: '[data-prev-arrow]',
        nextArrow: '[data-next-arrow]',
    };
  }
  
  constructor(compEl) {
    super(compEl);
    this.close = this.$component.querySelector(this.SELECTORS.close);
    this.addBtn = this.$component.querySelector(this.SELECTORS.addBtn);
    this.addedBtn = this.$component.querySelector(this.SELECTORS.addedBtn);
    this.lookbookPage = document.querySelector(this.SELECTORS.lookbookPage);
    this.lookbookCard = this.$component.querySelectorAll(this.SELECTORS.lookbookCard);
    this.uuid = this.$component.getAttribute('data-uuid');
    this.parent = this.$component.parentElement;
    this.prevZindex = this.parent.dataset.zindex;
    this.carousel = this.$component.querySelector(this.SELECTORS.carousel);
    this.trackingComponent = new TrackingComponent();

    this.mainImage = null;
    this.productsImages = null;
    this.carouselInitialized = false;
    this.currentIndex = new Array();
    this.arrows = new Map();
    this.slidesMap = new Array();
    this.slidesWidth = 0;
    this.slidesWidthMap = 0;
    this.lookbookCardComponents = [];
  }

  loadMainImage() {
    let mainImgContainer = this.$component.querySelector('[data-img]');
    let dataImg = mainImgContainer?.dataset?.img;

    if (mainImgContainer && dataImg) {
        let picture = document.createElement('picture');
        let source = document.createElement('source');
        let img = document.createElement('img');

        // Set attributes to elements
        source.setAttribute('srcset', dataImg);
        source.setAttribute('type', 'image/webp');
        img.src = dataImg;
        img.setAttribute('data-src', dataImg);

        // Append elements
        picture.append(source, img);
        mainImgContainer.appendChild(picture);

        // Set for following times
        this.mainImage = dataImg;
    }
  }

  loadProductsImages() {
    const productsImagesContainers = this.$component.querySelectorAll('[data-img-carousel]');
    if (productsImagesContainers && productsImagesContainers.length) {
        productsImagesContainers.forEach(imgContainer => {
            const imgSrc = imgContainer?.dataset?.imgCarousel;
            if (imgSrc) {
                let picture = document.createElement('picture');
                let source = document.createElement('source');
                let img = document.createElement('img');

                // Set attributes to elements
                source.setAttribute('srcset', imgSrc);
                source.setAttribute('type', 'image/webp');
                img.src = imgSrc;
                img.setAttribute('data-src', imgSrc);

                // Append elements
                picture.append(source, img);
                imgContainer.appendChild(picture);
            }
        });
        this.productsImages = productsImagesContainers;
    }
  }

  closeModal() {
    this.$component.classList.remove('show');
    document.body.style.overflowY = 'auto';

    this.lookbookPage.classList.remove('block-scroll');
    this.parent.style.zIndex = this.prevZindex ? this.prevZindex : 0 ;
  }

  // modalContext comes from LookBookSubComponent and helps manage the modal state  
  // if the modal is already open, there s no need to trigger the event multiple times  
  // when clicking the modal close button, the modal state will be updated accordingly
  openModal(modalContext) {
    this.trackingComponent.actions.lookbookView(this.lookbookCardComponents);
    this.$component.classList.add('show');
    document.body.style.overflowY = 'hidden';

    this.parent.style.zIndex = '3';
    this.lookbookPage.classList.add('block-scroll');

    this.close.addEventListener('click', (event) => {
      event.stopPropagation();
      this.closeModal();
      if(modalContext){
        modalContext.isOpen = false;
      }
    });

    if (!this.mainImage) this.loadMainImage();
    if (!this.productsImages) this.loadProductsImages();
    this.$emit(this.$customEvents.LB_MODAL_EVENTS.shown);

    if (!this.carouselInitialized) {
      this.initCarousel();
      this.setArrowVisibility();
      this.bindArrowEvents();
      this.centerCards();
    }
  }

  initCarousel() {
    const children = this.carousel.children;
    const childrenArray = Array.from(children);
    const filteredChildrenArray = childrenArray.filter((el) => el.classList.contains(this.SELECTORS.carouselElement));
    this.currentIndex.push(0);
    this.arrows.set(0, {
      prev: this.carousel.parentElement.querySelector(this.SELECTORS.prevArrow),
      next: this.carousel.parentElement.querySelector(this.SELECTORS.nextArrow)
    });
    this.slidesMap = filteredChildrenArray;
    let cs = window.getComputedStyle(this.slidesMap[0]);
    this.slidesWidth = parseFloat(this.slidesMap[0].getBoundingClientRect().width);
    this.slidesWidthMap = this.slidesWidth + parseFloat(cs.marginRight);

    this.carouselInitialized = true;
  }

  setArrowVisibility() {
    const carouselWidth = this.carousel.getBoundingClientRect().width;
    const children = Array.from(this.carousel.children);
    const childrenWidth = (this.slidesWidthMap * (children.length - 1)) + this.slidesWidth;
    if (childrenWidth < carouselWidth) {
      this.arrows.forEach((arrow) => {
        arrow.prev.style.display = 'none';
        arrow.next.style.display = 'none';
      })
    }
  }

  bindArrowEvents() {
    this.arrows.forEach((elem, index) => {
      if (elem.next.dataset.uuid == this.uuid) {
        elem.next.addEventListener("click", () => {
          let nextIndex = (this.currentIndex[index] + 1)/*  % numSlides */;

          this.moveToSlide(nextIndex, index);
        })
      }
      
      if (elem.prev.dataset.uuid == this.uuid) {
        elem.prev.addEventListener("click", () => {
          let prevIndex = (this.currentIndex[index] - 1)/*  % numSlides */;

          if (prevIndex < 0) {
            prevIndex = 0;
          }
          this.moveToSlide(prevIndex, index);
        })
      }
    })
  }

  moveToSlide(index, carIndex) {
    const px = this.slidesWidthMap * index;
    this.carousel.scroll({
      left: px,
      behavior: 'smooth'
    });
    this.currentIndex[carIndex] = index;
  }

  centerCards() {
    if($('.w-lookbook-gallery').length && isMobile(MobileBreakpoint.Max767)){
      $('.w-lookbook-gallery').each((index,gallery) =>{
        let scrollLeft = ($('.lb-g__wrapper', gallery).get(0).scrollWidth - $('.lb-g__wrapper', gallery).width()) / 2;
        $('.lb-g__wrapper', gallery)[0].scrollTo(scrollLeft, 0);
      })
    }
  }
  
  bindEvents() {
    let ctx = this;

    this.$on(this.$customEvents.LB_MODAL_EVENTS.show, ( { payload } ) => {
        if (payload.uuid == ctx.uuid) {
            ctx.$component.classList.add('show');
            document.body.style.overflowY = 'hidden';
            
            ctx.parent.style.zIndex = '8';
            ctx.lookbookPage.classList.add('block-scroll');

            ctx.close.addEventListener('click', () => {
                ctx.$emit(ctx.$customEvents.LB_MODAL_EVENTS.hide, ({ uuid: payload.uuid }));
            });
            if (!this.mainImage) this.loadMainImage();
            if (!this.productsImages) this.loadProductsImages();
            ctx.$emit(ctx.$customEvents.LB_MODAL_EVENTS.shown, payload);
        }
    });

    this.$on(this.$customEvents.LB_MODAL_EVENTS.hide, ( { payload } ) => {
        // if ( payload.uuid == ctx.uuid ) {
            ctx.$component.classList.remove('show');
            document.body.style.overflowY = 'auto';
            ctx.lookbookPage.classList.remove('block-scroll');

            ctx.parent.style.zIndex = ctx.prevZindex ? ctx.prevZindex : 0 ;
    
            ctx.$emit(ctx.$customEvents.LB_MODAL_EVENTS.shown, payload);
        // }
    });
  }

  render() {
    this.bindEvents();

    if(this.lookbookCard && this.lookbookCard.length ) {
        this.lookbookCard.forEach(element => {
            let component = new LookbookProductCard(element);
            component.render();
            this.lookbookCardComponents.push(component);
        });
    }
  }

  animateTextOnce() {
    this.addBtn.classList.add('animate');
    this.addedBtn.classList.add('animate');
    this.button.removeEventListener('click', animateTextOnce);
  }
}
